export enum TicketType {
  all = 'all',
  purchased = 'purchased',
  shared = 'shared',
  received = 'received',
}
